import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { Issue } from './ViewIssues';
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';
import firebase from 'firebase/app';
import 'firebase/storage';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { toRoman } from 'roman-numerals';

interface Props {
    issue: Issue;
}

export function useDownloadUrl(issueUrl?: string): string | null {
    const [url, setUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!issueUrl) {
            return;
        }

        firebase
            .storage()
            .refFromURL(issueUrl)
            .getDownloadURL()
            .then(e => {
                setUrl(e);
            });
    }, [issueUrl]);

    return url;
}

export default function IssueCard(
    {
        issue
    }: Props
): ReactElement {
    const url = useDownloadUrl(issue.url);

    const [loaded, setLoaded] = useState(false);
    const handleLoadSuccess = useCallback(() => {
        setLoaded(true);
    }, []);

    const history = useHistory();

    const [previewHeight, setPreviewHeight] = useState(window.innerWidth > 425 ? 500 : undefined);
    const [previewWidth, setPreviewWidth] = useState(window.innerWidth <= 425 ? 500 : undefined);
    useEffect(() => {
        window.onresize = () => {
            setPreviewHeight(window.innerWidth > 425 ? 500 : undefined);
            setPreviewWidth(window.innerWidth <= 425 ? 500 : undefined);
        };
    }, []);

    return (
        <div
            className='issue-card'
            onClick={() => history.push(`/view/${issue.id}`)}
        >
            <Document
                file={url}
                options={{
                    cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
                    cMapPacked: true,
                }}
                className={`preview${(loaded ? '' : ' loading')}`}
            >
                <Page
                    renderMode={loaded ? 'svg' : 'none'}
                    pageNumber={1}
                    height={previewHeight}
                    width={previewWidth}
                    onLoadSuccess={handleLoadSuccess}
                />
            </Document>
            <div className='card-contents'>
                <h2 className='issue-title'>
                    {
                        issue.name
                    }
                </h2>
                <h4 className='issue-number'>
                    Issue&nbsp;
                    <span className='numeral'>
                        {
                            toRoman(
                                issue.number
                            )
                        }
                    </span>
                </h4>
                <span className='date'>
                    Published&nbsp;
                    {
                        moment(issue.published.toMillis())
                            .fromNow()
                    }
                </span>
            </div>
        </div>
    );
}
